import { createSlice } from '@reduxjs/toolkit'
import api from './api'

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: { stats: null },
  reducers: {
    SET_STATS: (state, action) => { state.stats = action.payload }
  }
})

const { SET_STATS } = dashboardSlice.actions

export const GET_DASHBOARD_STATS = () => async (dispatch) => {
  const data = await api.getDashboardStats()
  dispatch(SET_STATS(data.data))
  return data.data
}

export default dashboardSlice.reducer
